import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../../Modals/ModalStyle.css";

const EditLabelModal = ({ openEditLabel, closeEditLabel }) => {
  const [showEditLabel, setShowEditLabel] = useState(false);

  useEffect(() => {
    if (openEditLabel) {
      setShowEditLabel(true)
    }
  }, [openEditLabel]);
  
  const closeEditLabelModal = () => {
    setShowEditLabel(false);
    closeEditLabel(true)
  }

  // const submitEditLabel = async (event) => {
  //   try {
  //     if (event) {
  //       event.preventDefault();
  //     }
  //     if (LabelName) 
  //     {
  //       await middleware.post("labels", {
          
  //       }).then(() => window.location.reload());      
        
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  
  return (
    <Modal
        id="modalEditLabel"
        show={showEditLabel}
        onHide={() => closeEditLabelModal()}
        centered
        size="xl"
      >
        <Modal.Header className="modalTop justify-content-between">
          <h4 className='ms-3 fw-semibold'>Label aanpassen</h4>
          <button variant="transparent" className=' btn' onClick={() => closeEditLabelModal()}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter">
          <div className="contendModal w-100 d-flex flex-column">
            <label className='fw-semibold mb-2'>Naam</label>
            <input className='standardInput'/>
          </div>
        </Modal.Body>
        <Modal.Footer className="modalBottom">
          <button
            type="sumbit"
            className="btn lightBlueStandardButton"
            onClick={() => {
              closeEditLabelModal()
            }}
          >
            opslaan
          </button>
        </Modal.Footer>
      </Modal>
  );
}

export default EditLabelModal;
